// Service pour gérer l'authentification Elasticsearch
class ElasticAuthService {
  constructor() {
    this.STORAGE_KEY = 'elastic_credentials';
  }

  // Récupérer les credentials du localStorage
  getCredentials(zone) {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      if (!stored) return null;
      
      const credentials = JSON.parse(stored);
      return credentials[zone] || null;
    } catch (error) {
      console.error('Erreur récupération credentials Elasticsearch:', error);
      return null;
    }
  }

  // Sauvegarder les credentials dans le localStorage
  saveCredentials(zone, username, password) {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      const credentials = stored ? JSON.parse(stored) : {};
      
      // Encoder en base64 pour Basic Auth
      const token = btoa(`${username}:${password}`);
      
      credentials[zone] = {
        username,
        token,
        savedAt: new Date().toISOString()
      };
      
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(credentials));
      return true;
    } catch (error) {
      console.error('Erreur sauvegarde credentials Elasticsearch:', error);
      return false;
    }
  }

  // Supprimer les credentials d'une zone
  clearCredentials(zone) {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      if (!stored) return;
      
      const credentials = JSON.parse(stored);
      delete credentials[zone];
      
      if (Object.keys(credentials).length === 0) {
        localStorage.removeItem(this.STORAGE_KEY);
      } else {
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(credentials));
      }
    } catch (error) {
      console.error('Erreur suppression credentials Elasticsearch:', error);
    }
  }

  // Supprimer tous les credentials
  clearAllCredentials() {
    try {
      localStorage.removeItem(this.STORAGE_KEY);
    } catch (error) {
      console.error('Erreur suppression tous credentials Elasticsearch:', error);
    }
  }

  // Vérifier si des credentials existent pour une zone
  hasCredentials(zone) {
    return this.getCredentials(zone) !== null;
  }
}

export default new ElasticAuthService();
